import { defineComponent as _defineComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'FormModalLayout',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  emits: ["back"],
  setup(__props, { expose: __expose }) {
  __expose();

  

  

const __returned__ = {  }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})